import TasksProvider from "context/client/tasks";
import NewTaskProvider from "context/client/new_task";

import { NewTaskContent } from "page_components/client/tasks";

const NewTasks = () => (
  <TasksProvider>
    <NewTaskProvider>
      <NewTaskContent />
    </NewTaskProvider>
  </TasksProvider>
);

export default NewTasks;
